import { render, staticRenderFns } from "./ConfirmInstall.vue?vue&type=template&id=82b968be&"
import script from "./ConfirmInstall.vue?vue&type=script&lang=js&"
export * from "./ConfirmInstall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports